import { OpeningHoursExt } from './OpeningHoursExt';
import { LoadProfile } from '@/dto/scenario/load/LoadProfile';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class LoadProfileExt extends DtoExt {

  public static fromDto(dto: LoadProfile): LoadProfileExt {
    return new LoadProfileExt({
      annualAverageSiteConsumption: dto.annualAverageSiteConsumption,
      hasMonthlyAverageSiteConsumption: dto.hasMonthlyAverageSiteConsumption,
      monthlyAverageSiteConsumption: dto.monthlyAverageSiteConsumption,
      hasDifferentLoadProfileAfter: dto.hasDifferentLoadProfileAfter,

      profileBeforeOpeningHours: dto.profileBeforeOpeningHours &&
        OpeningHoursExt.fromDto(dto.profileBeforeOpeningHours),
      profileBeforeHasSameConsumptionAllDayLong: dto.profileBeforeHasSameConsumptionAllDayLong,
      profileBeforeNightConsumptionPercentage: dto.profileBeforeNightConsumptionPercentage,

      profileAfterOpeningHours: dto.profileAfterOpeningHours &&
        OpeningHoursExt.fromDto(dto.profileAfterOpeningHours),
      profileAfterHasSameConsumptionAllDayLong: dto.profileAfterHasSameConsumptionAllDayLong,
      profileAfterNightConsumptionPercentage: dto.profileAfterNightConsumptionPercentage
    } as any);
  }

  public annualAverageSiteConsumption: number | null = null;

  public hasMonthlyAverageSiteConsumption: boolean | null = null;
  public monthlyAverageSiteConsumption: number[] | null = null;

  public hasDifferentLoadProfileAfter: boolean | null = null;

  public profileBeforeOpeningHours: OpeningHoursExt | null = null;
  public profileBeforeHasSameConsumptionAllDayLong: boolean | null = null;
  public profileBeforeNightConsumptionPercentage: number | null = null;

  public profileAfterOpeningHours: OpeningHoursExt | null = null;
  public profileAfterHasSameConsumptionAllDayLong: boolean | null = null;
  public profileAfterNightConsumptionPercentage: number | null = null;

  constructor(options?: LoadProfileExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.annualAverageSiteConsumption = options.annualAverageSiteConsumption;

      // this.hasMonthlyAverageSiteConsumption = options.hasMonthlyAverageSiteConsumption;
      // this.monthlyAverageSiteConsumption = options.monthlyAverageSiteConsumption;

      // this.hasDifferentLoadProfileAfter = options.hasDifferentLoadProfileAfter;

      // this.profileBeforeOpeningHours = options.profileBeforeOpeningHours;
      // this.profileBeforeHasSameConsumptionAllDayLong = options.profileBeforeHasSameConsumptionAllDayLong;
      // this.profileBeforeNightConsumptionPercentage = options.profileBeforeNightConsumptionPercentage;

      // this.profileAfterHasSameConsumptionAllDayLong = options.profileAfterHasSameConsumptionAllDayLong;
      // this.profileAfterNightConsumptionPercentage = options.profileAfterNightConsumptionPercentage;
      // this.profileAfterOpeningHours = options.profileAfterOpeningHours;
    }
  }

  public toDto(): LoadProfile {
    return new LoadProfile({
      annualAverageSiteConsumption: this.annualAverageSiteConsumption,
      hasMonthlyAverageSiteConsumption: this.hasMonthlyAverageSiteConsumption,
      monthlyAverageSiteConsumption: this.monthlyAverageSiteConsumption,
      hasDifferentLoadProfileAfter: this.hasDifferentLoadProfileAfter,

      profileBeforeOpeningHours: this.profileBeforeOpeningHours && this.profileBeforeOpeningHours.toDto(),
      profileBeforeHasSameConsumptionAllDayLong: this.profileBeforeHasSameConsumptionAllDayLong,
      profileBeforeNightConsumptionPercentage: this.profileBeforeNightConsumptionPercentage,

      profileAfterOpeningHours: this.profileAfterOpeningHours && this.profileAfterOpeningHours.toDto(),
      profileAfterHasSameConsumptionAllDayLong: this.profileAfterHasSameConsumptionAllDayLong,
      profileAfterNightConsumptionPercentage: this.profileAfterNightConsumptionPercentage
    });
  }
}
